module.exports = __webpack_public_path__ + "static/img/anxunMobel21.339988ff.png";